document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".bh-size-guide").forEach(function (guide) {
    const toggle = guide.querySelector(".bh-unit-toggle");
    const labels = guide.querySelectorAll(".bh-unit-label");
    const convertItems = guide.querySelectorAll(".convert-unit");
    const notes = guide.querySelectorAll("[data-original]");

    if (!toggle || !convertItems.length) return;

    function convertToCM(text) {
      return text.replace(/(\d+(\.\d+)?)"/g, function (match, num) {
        return (num * 2.54).toFixed(1).replace(".0", "") + " cm";
      });
    }

    toggle.addEventListener("change", function () {
      const isCM = toggle.checked;

      convertItems.forEach(function (item) {
        const original = item.getAttribute("data-inches");

        if (!original) return;

        item.textContent = isCM ? convertToCM(original) : original;
      });

      notes.forEach(function (note) {
        const original = note.getAttribute("data-original");

        if (!original) return;

        note.textContent = isCM ? convertToCM(original) : original;
      });

      if (labels.length >= 2) {
        labels[0].classList.toggle("active", !isCM);
        labels[1].classList.toggle("active", isCM);
      }
    });
  });
});